import React, { useState, useEffect, useRef } from "react";
import "../styles/Details.css";
import Preview from "../assets/view.png"
import { useNavigate } from "react-router-dom";
import { DateRangePicker } from 'react-date-range';
import CalendarGrey from '../assets/Calendar Dark.svg'
import CalendarBlue from '../assets/Calendar Blue.svg'
import { VerticalAlignBottomOutlined, InfoCircleOutlined, FilterOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Table, Tooltip, Image, Spin, Tag, Modal, Card } from "antd";
import moment from "moment";
import { formatDate, formatDateAndTimeInlocal, formateDateForAuditlog } from "../utils/dateFormat";
import AuditLogsServices, { canDownloadReport, downloadDocument, getAuditLogsClinics, getDocument, handleFaxRetry } from "../services/AuditLogsService";
import FilterComponent from "../components/FilterComponent";
import { getMonthlyFaxReview } from "../services/MonthlyFaxService";
const { Column } = Table;

function AuditLogs() {
    document.title = "LunaJoy Dashboard"
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalComponent, setModalComponent] = useState();
    const [data, setData] = useState([]);
    const [clinicNames, setClinicNames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [filtered, setFiltered] = useState([])
    const [filters, setFilters] = useState({});
    const [showDatePicker, setShowDatePicker] = useState(false)
    const [dateRangeFilter, setDateRangeFilter] = useState([]);
    const datePickerRef = useRef(null);
    const buttonRef = useRef(null);
    const clinicSet = new Set();
    const [filterClinic, setFilterClinic] = useState(null);
    const [faxFilters, setFaxFilters] = useState({});
    const [faxType, setFaxType] = useState(null);
    const [faxStatus, setFaxStatus] = useState(null);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(20)
    const [frequency, setFrequency] = useState(null);
    const navigate = useNavigate();
    const [isReviewedFalseCount, setIsReviewedFalseCount] = useState(0);

    const filterCardRef = useRef(null);
    const filterButtonRef = useRef(null);



    const handleTableChange = (pagination, filters) => {
        setFilters(filters);
        setLoading(true)
        setCurrentPage(pagination.current)
        setPageLimit(pagination.pageSize)
        setLoading(false)
    };

    const handleClickOutside = (event) => {
        if (
          datePickerRef.current &&
          !datePickerRef.current.contains(event.target) &&
          buttonRef.current &&
          !buttonRef.current.contains(event.target)
        ) {
          setShowDatePicker(false);
          
        }
    
        if (
          filterButtonRef.current &&
          !filterButtonRef.current.contains(event.target) &&
          filterCardRef.current &&
          !filterCardRef.current.contains(event.target)
        ) {
          setIsFilterVisible(false);
          
        }
      };

    const getSixDaysAgoFromCurrentDate = () => {
        const today = new Date();
        const sixDaysAgo = new Date(today);
        sixDaysAgo.setDate(today.getDate() - 6);
        return sixDaysAgo;
    };

    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        },
    ]);

    const handleDateChange = (ranges) => {
        setDateRange([ranges.selection]);

    };

    const handleToggleDatePicker = () => {
        setShowDatePicker(!showDatePicker);
    };

    const handleClose = () => {
        setIsFilterVisible(false);
    };

    // dateFormatGeneric
    const startDate = formateDateForAuditlog(dateRange[0].startDate)
    const endDate = formateDateForAuditlog(dateRange[0].endDate)
    const momentFormatStartDate = moment(startDate).format("D/M/YYYY");
    const momentFormatEndDate = moment(endDate).format("D/M/YYYY");

    useEffect(() => {
        const getData = setTimeout(() => {
            loadData();
        }, 400);

        return () => {
            clearTimeout(getData);
        }
    }, [refresh, filterClinic, faxStatus, faxType, startDate, endDate, faxFilters]);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    function checkValueTypeFreq(value){
        if(value === "Immediate"){
            return true;
        }
        if(value === "Daily"){
            return true;
        }
        if(value === "Weekly"){
            return true;
        }
        if(value === "Monthly"){
            return true;
        }

        return false;
    }

    async function loadData() {
        try {
            let typeFax = faxType;
            if(checkValueTypeFreq(faxType) && checkValueTypeFreq(faxFilters?.frequency)){
                typeFax = null;
            }

            setLoading(true);
            await loadClinicData();
            const details = await getAuditLogsClinics(filterClinic, typeFax, faxStatus, startDate, endDate, faxFilters?.patientName, faxFilters?.patientPhone, faxFilters?.frequency);
            setTotalItems(details.totalItems === 0 ? 1 : details.totalItems)
            setData(
                details.map((record) => {
                    return {
                        id: record.id,
                        clinic: record.clinic,
                        channel: record.channel,
                        createdAt: record.createdAt,
                        document: record.document,
                        type: record.type,
                        status: record.status,
                        retryCount: record.retryCount,
                        payload: record.payload,
                        updatedAt: record.updatedAt,
                        frequency: record.frequency,
                        errorMessage: record.errorMessage
                    };
                })
            );
        } catch (e) {
            console.log(e)
            Modal.confirm({
                title: 'Error Message',
                content: 'Oops! Error in Fetching data',
                okText: 'Ok',
                cancelButtonProps: { style: { display: 'none' } },
                onOk: async () => {
                    console.log("Error in Fetching data");
                },
            });
        } finally {
            setLoading(false); // Reset loading once data fetching is complete
        }
    }

    function formatDateFromTimestamp(timestamp) {
        const date = new Date(parseInt(timestamp, 10));

        return formatDate(date)
    }

    const handleDownloadDocument = async (record) => {
        setLoading(true);
        await downloadDocument(record);
        setLoading(false);
    }

    const handlePreviewDocument = async (record) => {
        setLoading(true);
        setModalComponent(null);
        const pdfBlob = await getDocument(record);
        const pdfPreview = <object key={pdfBlob} style={{ width: '95%', height: '95vh' }} data={pdfBlob}></object>

        setModalComponent(pdfPreview);
        setModalTitle("Audit Preview");
        setIsModalOpen(true);
        setLoading(false);
        
        return () => {
            URL.revokeObjectURL(pdfBlob);
        };
    }

    const handleModalClose = async () => {
        setModalComponent(null);
        setIsModalOpen(false);
    }

    const handleRetry = async (record) => {
        try {
            setLoading(true);
            await handleFaxRetry(record.id);
            setLoading(false);
            loadData();
        } catch (error) {
            Modal.warning({
                title: 'Oops! Error in Retrying',
                content: error.message,
                okText: 'Ok',
                cancelButtonProps: { style: { display: 'none' } },
                onOk: async () => {
                    loadData();
                },
            });
        }
        finally {
            setLoading(false);
        }
    };
    const [status, setStatus] = useState('Pending');
    // const [failedStatus, setFailedStatus] = useState('Pending');

    const failedStatus = 'Failed'
    const successStatus = 'Success'

    const filteredData = data.filter((item) => {
        return (!filtered.clinic || (item.clinic === filtered.clinic));
    });
    const filteredDataPending = filteredData.filter((item) => {
        return item.status === status;
    });
    const filteredDataFailed = filteredData.filter((item) => {
        return item.status === failedStatus;
    });
    const filteredDataSuccess = filteredData.filter((item) => {
        return item.status === successStatus;
    });

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleFilter = () => {
        setIsFilterVisible(true);
    };

    const [pendingTimestamp, setPendingTimestamp] = useState(new Date());

    useEffect(() => {
        setTimeout(() => {
            setStatus('Pending');
            setPendingTimestamp(new Date());
        }, 3000);
    }, []);

    const calculateDateDifference = (pendingTimestamp) => {
        const date1Millis = pendingTimestamp.getTime();
        const date2Millis = new Date().getTime();
    
        const differenceMillis = Math.abs(date2Millis - date1Millis);
    
        const differenceMinutes = differenceMillis / (1000 * 60);
    
        
        const roundedDifferenceMinutes = Math.round(differenceMinutes);
    
        return roundedDifferenceMinutes;
    };

    const getStatusText = (status, record) => {
        let pendingTimestamp = new Date(record.createdAt)
        const minuteDifference =calculateDateDifference(pendingTimestamp)
        if (status === 'Success') {
            return <p>Sent <br />{formatDateAndTimeInlocal(record.updatedAt)}</p>;
        } else if (status === 'Pending' && pendingTimestamp) {
            return (
                <p>
                    Pending
                    <br />
                    {minuteDifference > 1
                        ? `since ${minuteDifference} minutes`
                        : `since ${minuteDifference} minute`}
                </p>
            );
        } else if (status === 'Failed') {
            return (
                <p>
                    Failed
                    <br />
                    {record?.errorMessage}
                </p>
            );
        } else {
            return status;
        }
    };
    
    const getStatusTextColor = (status) => {
        if (status === 'Success') {
            return 'green';
        } else if (status === 'Pending') {
            return 'orange';
        } else if (status === 'Failed') {
            return 'red';
        } else {
            return 'black';
        }
    };

    async function loadClinicData() {
        try {
            const details = await getAuditLogsClinics(filterClinic, faxType, faxStatus, startDate, endDate);
            setTotalItems(details.totalItems === 0 ? 1 : details.totalItems)
            details.map((data) => {
                clinicSet.add(data.clinic);
            });
            setClinicNames([...clinicSet].sort());
        } catch (e) {
            console.log(e);
            Modal.confirm({
                title: "Error Message",
                content: "Oops! Error in Fetching data",
                okText: "Ok",
                onOk: async () => {
                    console.log("Error in Fetching data");
                },
                cancelButtonProps: { style: { display: 'none' } }
            });
        }
    };

    async function loadMonthlyFaxData() {
        try {
            setLoading(true);
            const logs = await getMonthlyFaxReview();
            const count = logs.reduce((acc, entry) => acc + (entry.isReviewed === false ? 1 : 0), 0);
            setIsReviewedFalseCount(count);
        } catch (e) {
            console.log(e)
            Modal.confirm({
                title: 'Error Message',
                content: 'Oops! Error in Fetching data',
                okText: 'Ok',
                cancelButtonProps: { style: { display: 'none' } },
                onOk: async () => {
                    console.log("Error in Fetching data");
                },
            });
        } finally {
            setLoading(false);
        }
    }

    const handleButtonClick = () => {
        setShowPopup(true);

    };

    const closePopup = () => {
        setShowPopup(false);
    };

    const setSearchField = (e) => {
        setFaxFilters({...faxFilters, [e.target.name]: e.target.value || null});
    }

    return (
        <div id="dashboard-container">
            <div className='row styleFilterRow'>
                <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontWeight: 500 }}>Total Fax</span>
                        <Tag>
                            <strong style={{ fontSize: 16 }}>{filteredData.length === 0 ? 0 : filteredData.length}</strong>
                        </Tag>
                        <Button style={{ fontsize: 16, padding: 5 }} onClick={handleButtonClick}>Fax Report</Button>
                        {showPopup && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 100,
                                    transition: "transform 0.3s ease-out",
                                    boxShadow: "0 0 10px rgba(0, 0, 0, 1.5)",
                                }}
                            >
                                <Card
                                    title="Fax Report Summary"
                                    bordered={true}
                                    extra={
                                        <Button type="Close" onClick={closePopup}>
                                            <CloseCircleOutlined />
                                        </Button>

                                    }
                                    style={{ width: '500px' }}
                                >
                                    <table style={{ width: '100%', marginTop: -15 }}>
                                        <thead>
                                            <tr>
                                                <th>Category</th>
                                                <th border style={{ textAlign: 'center' }}>Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td border style={{ border: '1px solid #e9ecef', }}>Total Number of Fax Generated</td>

                                                <td border style={{ border: '1px solid #e9ecef', textAlign: 'center' }}>{filteredData.length === 0 ? 0 : filteredData.length}</td>
                                            </tr>
                                            <tr>
                                                <td border style={{ border: '1px solid #e9ecef', }}>Total Number of Fax Sent </td>
                                                <td border style={{ border: '1px solid #e9ecef', textAlign: 'center' }}>{filteredDataSuccess.length === 0 ? 0 : filteredDataSuccess.length}</td>
                                            </tr>
                                            <tr>
                                                <td border style={{ border: '1px solid #e9ecef', }}>Successful Delivery</td>
                                                <td border style={{ border: '1px solid #e9ecef', textAlign: 'center' }}>{filteredDataSuccess.length === 0 ? 0 : filteredDataSuccess.length}</td>
                                            </tr>
                                            <tr>
                                                <td border style={{ border: '1px solid #e9ecef', }}>Unsuccessful Delivery</td>
                                                <td border style={{ border: '1px solid #e9ecef', textAlign: 'center' }}>{filteredDataFailed.length === 0 ? 0 : filteredDataFailed.length}</td>
                                            </tr>
                                            <tr>
                                                <td border style={{ border: '1px solid #e9ecef', }}>Delivery Pending</td>
                                                <td border style={{ border: '1px solid #e9ecef', textAlign: 'center' }}>{filteredDataPending.length === 0 ? 0 : filteredDataPending.length}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Card>
                            </div>
                        )}

                        <Button style={{ fontsize: 16, padding: 5, marginLeft: 10 }} onClick={() => navigate("/MonthlyFaxReview")}>
                            <span>Review Fax Reports</span>
                            {isReviewedFalseCount >= 1 && (
                                <span style={{ marginRight: '10px', marginLeft: '10px', marginBottom: '10px' }}>
                                    <Tooltip
                                        title={`Number of generated monthly fax yet to review ${isReviewedFalseCount}`}
                                        placement="right"
                                    >
                                        <InfoCircleOutlined style={{ position: "absolute", top: "0px", fontSize: "13px", color: 'red' }} />
                                    </Tooltip>
                                </span>
                            )}
                        </Button>

                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: '10px' }}>
                        <span className="dateStyling">
                            Filter
                        </span>
                        <div style={{ position: "relative" }}>
                            <Tooltip title="Filter" >
                                <FilterOutlined
                                    style={{ fontSize: "18px", cursor: "pointer" }}
                                    ref={filterButtonRef}
                                    onClick={handleFilter}
                                />
                            </Tooltip>

                            {isFilterVisible && (
                                <div
                                    style={{ position: "absolute", top: 0, right: 0, zIndex: 100 }} ref={filterCardRef}
                                >
                                    <Card
                                        title="Filter Options"
                                        bordered={true}
                                        extra={
                                            <Button type="Close" onClick={handleClose}>
                                                <CloseCircleOutlined />
                                            </Button>
                                        }
                                    >
                                        <FilterComponent
                                            clinicNames={clinicNames}
                                            filteredClinic={filterClinic}
                                            setFilteredClinic={setFilterClinic}
                                            faxType={faxType}
                                            setFaxType={setFaxType}
                                            faxStatus={faxStatus}
                                            setFaxStatus={setFaxStatus}
                                            from={"Fax"}
                                            setSearchField={setSearchField}
                                            filters={faxFilters}
                                        />
                                    </Card>
                                </div>
                            )}
                        </div>


                        <span className='dateStyling'>{momentFormatStartDate + ' to ' + momentFormatEndDate}</span>
                        <span ref={buttonRef} onClick={handleToggleDatePicker} className='marginAdjustCalendarToggleButton'>{showDatePicker ? <img src={CalendarBlue} alt="img" /> : <img src={CalendarGrey} alt="img" />}</span>
                        {showDatePicker && (
                            <div className="date-picker-container" ref={datePickerRef} style={{ position: 'absolute', zIndex: '9999', top: '10.5rem', display: 'flex', justifyContent: 'end', right: '30px' }}>
                                <DateRangePicker
                                    ranges={dateRange}
                                    onChange={handleDateChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Spin spinning={loading}>
                <Table
                    dataSource={filteredData}
                    pagination={{
                        current: currentPage,
                        total: totalItems,
                        pageSize: pageLimit,

                    }}
                    onChange={handleTableChange}
                    bordered={true}
                >
                    {!filtered.clinic && (
                        <Column
                            title="Clinic"
                            dataIndex="clinic"
                            key="clinic"


                        />
                    )}

                    <Column
                        title="Patient"
                        dataIndex="clinic"
                        key="payload"
                        render={(clinic, record) => (
                            record.type && (record.type.includes("Responsiveness")
                                || record.type.includes("Referral Status")
                                || record.type.includes("First Note")
                                || record.type.includes("Referral Confirmation")
                                || record.type.includes("Assessment Screening")) ?
                                record.payload.templateData ? (
                                    <p>{record.payload.templateData.firstName} {record.payload.templateData.lastName}<br /> {record?.payload?.templateData?.patientPhone || ''}</p>
                                ) : (
                                    "Not Applicable"
                                )
                                :
                                "Not Applicable"
                        )}


                    />

                    <Column
                        title="Type"
                        dataIndex="type"
                        key="type"
                    />

                    <Column
                        title="Frequency"
                        dataIndex="frequency"
                        key="frequency"
                    />

                    <Column
                        title="Status"
                        dataIndex="status"
                        key="updatedAt"
                        width={250}
                        render={(status, record) => (
                            <>
                                <Tag
                                    style={{
                                        textAlign: 'left', whiteSpace: 'wrap'
                                    }}
                                    color={getStatusTextColor(status)}
                                    key={status}
                                >
                                    {getStatusText(status, record)}
                                </Tag>
                            </>
                        )}
                    />

                    <Column
                        title="Retry Count"
                        dataIndex="retryCount"
                        key="retryCount"
                    />

                    <Column
                        title="Generated"
                        dataIndex="createdAt"
                        key="Generated"
                        width={130}
                        render={(date) => (
                            <>
                                <div>{date ? formatDateAndTimeInlocal(date) : " "}</div>
                            </>
                        )}

                    />

                    {canDownloadReport() && (
                        <Column
                            title="Download"
                            dataIndex="id"
                            key="id"
                            render={(id, record) => {
                                if (record.document) {
                                    return (
                                        <>
                                            <Tooltip title={"Download"}><VerticalAlignBottomOutlined onClick={() => handleDownloadDocument(record)}
                                                style={{ cursor: "pointer" }} /></Tooltip>

                                        </>
                                    )
                                }
                            }}
                        />
                    )}

                    <Column
                        title="Preview"
                        dataIndex="id"
                        key="id"
                        render={(id, record) => {
                            if (record.document) {
                                return (
                                    <>
                                        <Tooltip title={"Preview"}>
                                            <Image src={Preview} width={24} preview={false} onClick={() => handlePreviewDocument(record)} style={{ cursor: "pointer" }} />
                                        </Tooltip>
                                    </>
                                )
                            }
                        }}
                    />

                    <Column
                        title="Action"
                        dataIndex="id"
                        key="id"
                        render={(id, record) => (
                            <>
                                <Tooltip title={"Retry"} key={id}>
                                    <Button
                                        disabled={record.status !== 'Failed'}
                                        onClick={() => {
                                            handleRetry(record);
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Retry
                                    </Button>
                                </Tooltip>
                            </>
                        )}
                    />

                </Table>

                <Modal
                    title={modalTitle}
                    open={isModalOpen}
                    onOk={() => handleModalClose()}
                    onCancel={() => handleModalClose()}
                    maskClosable={true}
                    centered={true}
                    width={'100%'}
                    style={{ height: '95vh', padding: 0, overflow: 'auto' }}
                >
                    {modalComponent}
                </Modal>
            </Spin>

        </div >
    );
}


export default AuditLogs;
